<div class="container">
    <div *ngIf="isLoading" class="loadingOverlay center-loader">
        <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7"
            animationDuration="0.5s"></p-progressSpinner>
    </div>

    <div class="side-nav">
        <div class="neo-tabs vertical">
            @for(category of categories; track $index) {
            <div class="neo-tab" [class.active]="activeCategory === category" (click)="fetchForms(category)">
                {{ category | titlecase }}
            </div>
            }
        </div>
    </div>
    <div class="content-wrapper">
        <div class="content neo-scrollbar">
            @for(form of forms; track $index) {
            <div class="form-list">
                <div class="form-icon">
                    <img src="./assets/icons-svg/note.svg" />
                </div>
                <div class="form-details">
                    <span class="title">{{form.name}}</span>
                    <span class="created-details">
                        <span class="created-title">CREATED ON</span>
                        <span class="created-at">{{form.created_at | date: combineFormat || '-'}}</span>
                    </span>
                </div>
                <div class="form-action">
                    <button class="neo-action-item" icon="pi pi-eye" pButton *ngIf="userPrivileges.has('form_builder.view')"
                        (click)="onView(form)">
                    </button>
                    <button *ngIf="userPrivileges.has('form_builder.update')" class="neo-action-item" icon="pi pi-pen-to-square" pButton
                        [disabled]="!form.is_editable" (click)="onEdit(form)"
                        [pTooltip]="!form.is_editable ? 'Candidate data exists in this form. Editing form is not allowed' : ''"
                        tooltipPosition="top">
                    </button>
                    <button *ngIf="userPrivileges.has('form_builder.create')" class="neo-action-item" icon="pi pi-clone" pButton
                        (click)="onClone(form)">
                    </button>
                    <button *ngIf="userPrivileges.has('form_builder.delete')" class="neo-action-item" icon="pi pi-trash" pButton
                        [disabled]="!form.is_editable" (click)="onDelete(form)"
                        [pTooltip]="!form.is_editable ? 'Candidate data exists in this form. Deleting form is not allowed' : ''"
                        tooltipPosition="top">
                    </button>
                </div>
            </div>
            } @empty {
            <empty-state *ngIf="!isLoading">
                <empty-state-title>No Forms Found</empty-state-title>
                <empty-state-subtitle>Create a form by clicking on "Create New Form".</empty-state-subtitle>
            </empty-state>
            }
        </div>
    </div>
</div>

<p-dialog header="Create New Form" [(visible)]="createNewForm" [modal]="true" [closable]="true" [draggable]="false"
    [resizable]="false">
    <div style="width: 50vw;">
        <div class="dialog-content">
            <div class="neo-input-wrapper">
                <label for="form_name" required>Form Name</label>
                <input pInputText type="text" [(ngModel)]="formSettings.formName" id="form_name" placeholder="Enter form name" [class.invalid]="formSettings.touched && !formSettings.formName">
            </div>
            <div class="neo-input-wrapper">
                <label for="form_type" required>Form Type</label>
                <p-select big inputId="form_type" [options]="categoriesList" [(ngModel)]="formSettings.category"
                    placeholder="Select a category" [style]="{'width':'100%'}" optionLabel="label" optionValue="value"
                    appendTo="body">
                </p-select>
            </div>
            <div class="neo-input-wrapper">
                <label required>Logo</label>
                <div class="image-upload">
                    <div class="image-preview-container">
                        <ng-container *ngIf="formSettings.logoPreview; else showLogoUploadBtn">
                            <div class="upload-preview clickable" (click)="logoInputNew.click()">
                                <img [src]="formSettings.logoPreview" alt="Logo" title="Click to change logo">
                            </div>
                        </ng-container>
                        <ng-template #showLogoUploadBtn>
                            <button id="logo_image" class="upload-dropzone-btn" [disabled]="uploadingLogo" (click)="logoInputNew.click()" [class.invalid]="formSettings.touched && !formSettings.logoPreview">
                                <img src="assets/icons-svg/upload_file_icon.svg" alt="Upload" />
                                <p class="upload-text">
                                    Drag & Drop your files here or
                                    <span [style]="{ color: '#6944D6', 'text-decoration': 'underline' }">
                                        Choose Files
                                    </span>
                                </p>
                                <p class="format-text">
                                    Recommended png, jpeg and jpg only (Max File Size: 500KB)
                                </p>
                            </button>
                        </ng-template>
                        <input type="file" #logoInputNew style="display: none" (change)="onFileSelected($event, 'logo')"
                            accept="image/png, image/jpeg, image/jpg">
                    </div>
                </div>
            </div>
            <div class="neo-input-wrapper">
                <label for="form_name">Cover Image</label>
                <div class="image-upload">
                    <div class="image-preview-container">
                        <ng-container *ngIf="formSettings.coverPreview; else showCoverUploadBtnNew">
                            <div class="upload-preview clickable" (click)="coverInputNew.click()">
                                <img [src]="formSettings.coverPreview" alt="Cover" title="Click to change cover">
                            </div>
                        </ng-container>
                        <ng-template #showCoverUploadBtnNew>
                            <button id="cover_image" class="upload-dropzone-btn" [disabled]="uploadingCover" (click)="coverInputNew.click()">
                                <img src="assets/icons-svg/upload_file_icon.svg" alt="Upload" />
                                <p class="upload-text">
                                    Drag & Drop your files here or
                                    <span [style]="{ color: '#6944D6', 'text-decoration': 'underline' }">
                                        Choose Files
                                    </span>
                                </p>
                                <p class="format-text">
                                    Recommended png, jpeg and jpg only (Max File Size: 2MB)
                                </p>
                            </button>
                        </ng-template>
                        <input type="file" #coverInputNew style="display: none" (change)="onFileSelected($event, 'cover')"
                            accept="image/png, image/jpeg, image/jpg">
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-action">
            <button pButton pRipple type="submit" class="neo-btn" (click)="createForm()">Create</button>
        </div>
    </div>
</p-dialog>

<div *ngIf="false" class="formList-container">
    <div class="formList-header">
        <p>Forms List</p>
        <div [style]="{display: 'flex', alignItems:'center'}">
            <button *ngIf="userPrivileges.has('form_builder.create')" pButton type="button" label="Create Form"
                (click)="createForm()" [style]="{height: '38px'}"></button>
        </div>
    </div>

    <div class="formList-content">
        <div class="categories">
            <div *ngFor="let category of categories" class="category"
                [ngClass]="{'active': activeCategory === category}" (click)="fetchForms(category)">
                <p>{{ category | titlecase }}</p>
            </div>
        </div>

        <div class="forms-container">
            <div *ngIf="forms.length === 0" class="no-data">No forms found for {{ activeCategory }}.</div>

            <div *ngFor="let form of forms" class="form-item">
                <span>{{ form.name }}</span>
                <div class="actions">
                    <button *ngIf="userPrivileges.has('form_builder.view')" class="p-panel-header-icon p-link"
                        (click)="onView(form)">
                        <i class="pi pi-eye icon-center"></i>
                    </button>
                    <button *ngIf="userPrivileges.has('form_builder.update')" class="p-panel-header-icon p-link"
                        [disabled]="!form.is_editable" (click)="onEdit(form)"
                        [pTooltip]="!form.is_editable ? 'Candidate data exists in this form. Editing form is not allowed' : ''"
                        tooltipPosition="top">
                        <i class="pi pi-pencil icon-center"></i>
                    </button>
                    <button *ngIf="userPrivileges.has('form_builder.create')" 
                        class="p-panel-header-icon p-link" 
                        (click)="onClone(form)">
                        <i class="pi pi-clone icon-center" title="Clone Form"></i>
                    </button>
                    <button *ngIf="userPrivileges.has('form_builder.delete')" class="p-panel-header-icon p-link"
                        [disabled]="!form.is_editable" (click)="onDelete(form)"
                        [pTooltip]="!form.is_editable ? 'Candidate data exists in this form. Deleting form is not allowed' : ''"
                        tooltipPosition="top">
                        <i class="pi pi-trash icon-center"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>